import appConfig from "../config";
export const config = {};
const connections = new Map();

function buildWsUrl(authToken, appId, sessionId) {
  let url = appConfig.WS_BASE_URL;
  const params = new URLSearchParams({ app_id: appId, session_id: sessionId, access_key: authToken || "" });
  const path = url.includes("?") ? "&" + params.toString() : "?" + params.toString();
  return `${url}${path}`;
}

export function subscribeBotMessage(authToken, appId, sessionId, next, error) {
  const key = `${appId}:${sessionId}`;
  const wsUrl = buildWsUrl(authToken, appId, sessionId);

  const socket = new WebSocket(wsUrl);

  const onMessage = (event) => {
    try {
      const payloadString = typeof event.data === "string" ? event.data : JSON.stringify(event.data);
      next({ data: payloadString, appId, sessionId });
    } catch (e) {
      next({ data: String(event.data || ""), appId, sessionId });
    }
  };

  const onError = (evt) => {
    if (error) {
      error({ error: { errors: [{ message: evt?.message || "WebSocket error" }] } });
    }
  };

  const onClose = () => {
    if (error) {
      error({ error: { errors: [{ message: "Connection closed" }] } });
    }
  };

  socket.addEventListener("message", onMessage);
  socket.addEventListener("error", onError);
  socket.addEventListener("close", onClose);

  connections.set(key, { socket });

  return {
    unsubscribe: () => {
      try {
        socket.removeEventListener("message", onMessage);
        socket.removeEventListener("error", onError);
        socket.removeEventListener("close", onClose);
        if (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING) {
          socket.close();
        }
      } catch {}
      connections.delete(key);
    },
  };
}

export async function sendUserMessage(authToken, appId, sessionId, data) {
  const key = `${appId}:${sessionId}`;
  const entry = connections.get(key);

  function sendOver(socket) {
    try {
      const payload = typeof data === "string" ? data : JSON.stringify(data);
      socket.send(payload);
      return true;
    } catch (e) {
      return false;
    }
  }

  if (entry && entry.socket && entry.socket.readyState === WebSocket.OPEN) {
    sendOver(entry.socket);
    return Promise.resolve({ ok: true });
  }

  return new Promise((resolve, reject) => {
    const wsUrl = buildWsUrl(authToken, appId, sessionId);
    const socket = new WebSocket(wsUrl);

    const cleanup = () => {
      try { socket.close(); } catch {}
    };

    socket.addEventListener("open", () => {
      const ok = sendOver(socket);
      setTimeout(() => {
        cleanup();
        ok ? resolve({ ok: true }) : reject(new Error("Failed to send"));
      }, 20);
    });

    socket.addEventListener("error", (evt) => {
      cleanup();
      reject(evt);
    });

    socket.addEventListener("close", () => {
      if (socket.readyState !== WebSocket.OPEN) {
        reject(new Error("Connection closed"));
      }
    });
  });
}
